<template>
    <div class="shipping-table">
 <!--
        <div class="mb-2">
            <div v-if="mode === 'read'">
                <b-button variant="outline-secondary" @click="print">選択して印刷</b-button> <small>個別印刷は発送サービス名をクリック</small>
                <div>
                    <small class="text-danger">※作成後30日を過ぎると印刷できなくなります。</small>
                </div>
            </div>
        </div>
-->
        <div class="overflow-hidden" :style="'height: ' + styleHeight">
            <hot-table
                ref="hotTable"
                class="h-100"
                :mode="mode"
                :settings="hotSettings"
                @after-init="afterInit"
                @before-paste="beforePaste"
                />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import Handsontable from 'handsontable'
import AddressSearch from '@/components/AddressSearch.vue'
import TrackingCodeContent from '@/components/TrackingCodeContent.vue'
import VatContent from '@/components/VatContent.vue'
import ItemContent from '@/components/ItemContent.vue'
import BoxContent from '@/components/BoxContent.vue'
import ItemAttributeContent from '@/components/ItemAttributeContent.vue'
import CourierPlan from '@/components/CourierPlan.vue'
import moment from 'moment'
import { SHIPPING_ECMS_TABLE } from '@/plugins/handsontable'

const FIELDS = SHIPPING_ECMS_TABLE().FIELDS
const FIELDS_ALL = SHIPPING_ECMS_TABLE().FIELDS_ALL
const data2JsonObject = SHIPPING_ECMS_TABLE().METHODS.data2JsonObject

registerAllModules()

const clearShippingCourierPlan = (instance, row, scope) => {
    FIELDS_ALL.forEach((v, i) => {
        if (v.name === 'shipping_courier_plan') {
            instance.setDataAtCell(row, i, '')
        }
    })
}
const jsonObject2Data = (jsonObject) => {
    return jsonObject.map((v) => {
        return FIELDS_ALL.map((field) => {
            return field.load(v)
        })
    })
}
const urlValidator = (value, callback) => {
    let urls = value.split(',')
    if (urls.length !== 1) {
        callback(false)
    }
    return urlsValidator(value, callback)
}
const urlsValidator = (value, callback) => {
    if (value === null || value === '') {
        callback(true)
        return
    }
    let urls = value.split(',')
    for (let i = 0; i < urls.length; i++) {
        let url = urls[i]
        if (!isValidHttpUrl(url)) {
            callback(false)
            return
        }
    }
    callback(true)
}
const isValidHttpUrl = (string) => {
    let url
    try {
        url = new URL(string)
    } catch (_) {
        return false
    }
    return url.protocol === 'http:' || url.protocol === 'https:'
}

const app = {
    components: {
        HotTable,
        AddressSearch,
        VatContent,
        TrackingCodeContent,
        ItemContent,
        BoxContent,
        ItemAttributeContent,
        CourierPlan,
    },
    props: {
        mode: {
            type: String,
            required: true,
            default: 'read',
            // create, read, update
        },
        errors: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
        jsonKey: {
            type: String,
            required: false,
            default() {
                return null
            },
        },
        styleHeight: {
            type: String,
            required: false,
            default: 'calc(100vh - 25em)',
        },
    },
    watch: {
    },
    data() {
        return {
            hotRef: null,
            hotSettings: {
                _vue: this,
                licenseKey: 'non-commercial-and-evaluation',
                readOnly: true,
                rowHeaders: true,
                colHeaders: true,
                rowHeaderWidth: 80,
                stretchH: 'all',
                contextMenu: false,
                width: '100%',
                allowInsertColumn: false,
                allowInsertRow: false,
                allowRemoveColumn: false,
                allowRemoveRow: false,
                outsideClickDeselects: false,
                selectionMode: 'range',

                autoRowSize : false,
                viewportColumnRenderingOffset: 70,

                colHeaders: FIELDS_ALL
                    .map((v) => { return v.colHeader })
                    ,
                columns: FIELDS_ALL
                    .map((v) => { return v.column })
                    ,
//                data: [],
                hiddenColumns: {
                    copyPasteEnabled: false,
                },
                colWidths: this.colWidths,

                // event
                afterInit() {
                    this.rootElement.__vue__.$emit('after-init')
                },
                afterGetColHeader: function(col, TH) {
                    TH.className = 'text-left align-bottom'
                },
                afterGetRowHeader: this.afterGetRowHeader,
                afterChange: this.afterChange,
                afterOnCellMouseDown: this.afterOnCellMouseDown,
                beforePaste (data, range) {
                    this.rootElement.__vue__.$emit('before-paste', data, range)
                },
                cells: this.cells,
            },
            modal: {
                courier_plans: {},
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'auth_group',
            'trans',
            'shipping_address_default',
            'shipping_item_default',
            'shipping_default',
            'dimensional_weight',
            'create_shipping',
        ]),
    },
    async mounted() {
        window.$trans = this.trans
    },
    methods: {
        afterInit () {
            this.$watch('mode', (value_new, value_old) => {
                this.setup()
            }, {
                immediate: true, // オプション
            })
        },
        afterOnCellMouseDown (event, cell, el) {
//            let is_from_col = FIELDS.FROM
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_to_col = FIELDS.TO
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_importer_col = FIELDS.IMPORTER
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_shipping_col = FIELDS.SHIPPING
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_courier_col = FIELDS.COURIER
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
            if (cell.col === -1 || cell.row === -1) {
                return
            }
            let is_shipping_courier_plan_col = this.getColumnIndexByName('shipping_courier_plan') === cell.col

            if (! [ 'create', 'update', ].includes(this.mode)) {
                if (is_shipping_courier_plan_col) {
                    this.print()
                }
                return
            }
//
//            if (is_shipping_courier_plan_col) {
////            if (is_courier_col) {
//                this.$bvModal.show('modal-courier')
//            }
//
//            var now = new Date().getTime()
//            if(!(el.lastClick && now - el.lastClick < 1000)) {
//                el.lastClick = now
//                return
//            }
//
//            if (is_from_col) {
//                this.$bvModal.show('modal-from')
//            }
//            if (is_to_col) {
//                this.$bvModal.show('modal-to')
//            }
//            if (is_importer_col) {
//                this.$bvModal.show('modal-importer')
//            }
//            if (is_shipping_col) {
//                this.$bvModal.show('modal-shipping')
//            }
        },
        afterChange (changes, source) {
console.log('afterChange')
console.log(changes)
console.log(source)
            if (!changes) {
                return
            }

            let needs_calc_shipping_item_price_total = []
            let needs_calc_shipping_box_dimensional_weight = []
            let needs_clear_shipping_courier_plan = []
            for (let i = 0; i < changes.length; i++) {
                let row = changes[i][0]
                let col = changes[i][1]
                let column = FIELDS_ALL[col]

                switch (column.name) {
                    case 'shipping_item_quantity':
                    case 'shipping_item_price':
                        needs_calc_shipping_item_price_total.push(row)
                        break
                    case 'shipping_box_depth':
                    case 'shipping_box_width':
                    case 'shipping_box_height':
                        needs_calc_shipping_box_dimensional_weight.push(row)
                        break
                }
                if (column.name !== 'shipping_courier_plan') {
                    needs_clear_shipping_courier_plan.push(row)
                }
            }

            needs_calc_shipping_item_price_total = Array.from(new Set(needs_calc_shipping_item_price_total))
            needs_calc_shipping_box_dimensional_weight = Array.from(new Set(needs_calc_shipping_box_dimensional_weight))
            needs_clear_shipping_courier_plan = Array.from(new Set(needs_clear_shipping_courier_plan))
            if (needs_calc_shipping_item_price_total.length) {
                for (let i = 0; i < needs_calc_shipping_item_price_total.length; i++) {
                    calcShippingItemPriceTotal(this.$refs.hotTable.hotInstance, needs_calc_shipping_item_price_total[i])
                }
            }
            if (needs_calc_shipping_box_dimensional_weight.length) {
                for (let i = 0; i < needs_calc_shipping_box_dimensional_weight.length; i++) {
                    calcShippingBoxDimensionalWeight(this.$refs.hotTable.hotInstance, needs_calc_shipping_box_dimensional_weight[i], this)
                }
            }
            if (needs_clear_shipping_courier_plan.length) {
                for (let i = 0; i < needs_clear_shipping_courier_plan.length; i++) {
                    clearShippingCourierPlan(this.$refs.hotTable.hotInstance, needs_clear_shipping_courier_plan[i])
                }
            }
        },
        afterGetRowHeader (row, TH) {
            TH.className = 'text-left'
            const rowHeader = TH.querySelector('.rowHeader')
            rowHeader.innerHTML = ''
            switch (this.mode) {
                case 'create':
                    rowHeader.innerHTML = row + 1
                    break;
                case 'update':
                    rowHeader.innerHTML = row + 1
                    break;
                case 'read':
                default:
                    if (this.auth_level !== '300') {
                        break
                    }
                    const a = document.createElement('a')
                    a.innerText = '注文選択'
                    a.href = 'javascript:void(0)'
//                    a.className = 'text-danger'
                    a.setAttribute('row', row)
                    a.addEventListener('click', this.onClickSelectOrder)
                    rowHeader.appendChild(a)

//                    const delimiter = document.createElement('span')
//                    delimiter.innerText = ' / '
//                    rowHeader.appendChild(delimiter)
//
//                    const a_individual = document.createElement('a')
//                    a_individual.innerText = '個別'
//                    a_individual.href = 'javascript:void(0)'
//                    a_individual.setAttribute('row', row)
//                    a_individual.addEventListener('click', this.onClickSelectDataIndividual)
//                    rowHeader.appendChild(a_individual)
                    break;
            }
        },
        async onClickSelectOrder (event, individual = false) {
console.log('onClickSelectOrder')
            let row = Math.trunc(event.target.getAttribute('row'))
            if (Number.isNaN(row)) {
                return
            }
            let data = this.$refs.hotTable.hotInstance.getData()
            if (row >= data.length) {
                return
            }

            let row_sku = data[row][this.getColumnIndexByName('sku')]
            if (!individual) {
                this.$emit('click-select-data', row_sku)
                return
            }

const hot = this.$refs.hotTable.hotInstance
            const data_obj = this.getData()[row]
console.log('data_obj')
console.log(data_obj)
            const skus = data_obj.sku.split('\n')
            const rets = []
            for (let i = 0; i < skus.length; i++) {
//                let ret = data[row]
                const ret = this.$utils.copy(data[row])
console.log('ret:' + row)
console.log(ret)
                for (let j = 0; j < ret.length; j++) {
                    const cell = (ret[j] || '').split('\n')
//console.log('cell:' + j)
//console.log(cell)
                    if (cell.length > 1) {
                        ret[j] = cell[i]
                    }
                }




//                const multiple_columns = [
//                    'item_title',
//                    'quantity',
//                    'sku',
//                    'cost',
//                ]
//                const column_index = this.getColumnIndexByName('sku')
                ret = ret[this.getColumnIndexByName('sku')]
                rets.push(ret)
            }
            this.$emit('click-select-data', rets, true)
        },
        async onClickSelectDataIndividual (event) {
            this.onClickSelectData(event, true)
        },
        beforePaste (data, range) {
            if (this.mode !== 'create') {
                return
            }
            const startRow = range[0].startRow
            const count = this.$refs.hotTable.hotInstance.countRows()
            
            for (let i = 0; i < data.length + startRow - count; i++) {
                this.$refs.hotTable.hotInstance.alter('insert_row')
            }
        },
        cells (row, column, prop) {
            let cell = null
            try {
                cell = this.$refs.hotTable.hotInstance.getCell(row, column)
            } catch (e) {}
            let cellProperties = {
                readOnly: this.hotSettings.readOnly,
            }
            if (FIELDS_ALL[column].readOnly) {
                cellProperties.readOnly = true
            }
            if (cell) {
//                if (cellProperties.readOnly) {
//                    cell.style.backgroundColor = "#dddddd"
//                } else {
//                    cell.style.backgroundColor = "inherit"
//                }
//                console.log(cell.style)
            }
            return cellProperties
        },
        setup () {
            let hidden_columns = []
            const column_index_updated_at = this.getColumnIndexByName('updated_at')
            if (column_index_updated_at === -1) {
                return
            }
            switch (this.mode) {
                case 'create':
                    hidden_columns = []
//                        .concat(FIELDS.SYSTEM)
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .concat(FIELDS.PROFILE)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = false
//                    this.hotSettings.selectionMode = 'range'
                    break
                case 'update':
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .concat(FIELDS.PROFILE)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = false
//                    this.hotSettings.selectionMode = 'range'
                    break
                case 'read':
                default:
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .concat(FIELDS.PROFILE)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = true
//                    this.hotSettings.selectionMode = 'multiple'
                    break
            }

            // user_id
            const column_index_user_id = this.getColumnIndexByName('user_id')
            if (column_index_user_id !== -1) {
                FIELDS_ALL[column_index_user_id].column.type = 'handsontable'
                FIELDS_ALL[column_index_user_id].column.renderer = (instance, td, row, col, prop, value, cellProperties) =>  {
                    if (!value) {
                        td.innerText = ''
                        return td
                    }
                    td.innerText = value + ': '
                    let text = '不明なユーザー'
                    for (let i = 0; i < this.auth_group.length; i++) {
                        if ((value + '') === (this.auth_group[i].id + '')) {
                            text = this.auth_group[i].nickname
                            break
                        }
                    }
                    td.innerText += text
                    return td
                }
                FIELDS_ALL[column_index_user_id].column.handsontable = {
                    colHeaders: false,
                    autoColumnSize: true,
                    data: this.auth_group,
                    getValue() {
                        const selection = this.getSelectedLast()
                        return this.getSourceDataAtRow(Math.max(selection[0], 0)).id
                    },
                }
            }
            this.$set(
                this.hotSettings,
                'columns',
                FIELDS_ALL.map((v) => { return v.column })
            )

            // filxed columns
//            this.hotSettings.fixedColumnsLeft = this.getColumnIndexByName('shipping_tracking_codes') + 1
            // updateSettings
            this.$refs.hotTable.hotInstance.updateSettings(this.hotSettings)

            // hidden columns
            let pluginHiddenColumns = this.$refs.hotTable.hotInstance.getPlugin('hiddenColumns')
            pluginHiddenColumns.hideColumns(hidden_columns)

            this.$refs.hotTable.hotInstance.render()
            this.$forceUpdate()
        },
        getColumnIndexByName(name) {
            let field_names =
                FIELDS_ALL
                .map((v) => { return v.name })
            return field_names.indexOf(name)
        },
        getVisibleColumns () {
            let pluginHiddenColumns = this.$refs.hotTable.hotInstance.getPlugin('hiddenColumns')
            let visibleColumns = []
            for (let i = 0; i < this.$refs.hotTable.hotInstance.getColHeader().length; i++) {
                if (pluginHiddenColumns.getHiddenColumns().indexOf(i) === -1) {
                    visibleColumns.push(i)
                }
            }
            return visibleColumns
        },
        getVisibleColumnFirst () {
            let cols = this.getVisibleColumns()
            return cols.length ? cols[0] : 0
        },
        loadData (hits) {
            this.deselectCell()
            this.$refs.hotTable.hotInstance.loadData(this.jsonObject2Data(hits))
            this.setup()
            this.$forceUpdate()
        },
        loadPartialData (hits) {
            let range = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (!range) {
                let visibleColumn = this.getVisibleColumnFirst()
                this.$refs.hotTable.hotInstance.selectCell(0, visibleColumn, 0, visibleColumn)
                range = this.$refs.hotTable.hotInstance.getSelectedRange()
            }
            range = range[0]

            hits = this.jsonObject2Data(hits)

            let changes = [];
            for (let row = range.from.row; row <= range.to.row; row++) {
                for (let col = 0; col <= hits[0].length; col++) {
                    if (typeof hits[0][col] === 'undefined') {
                        continue
                    }
                    changes.push([ row, col, hits[0][col], ])
                }
            }
            this.$refs.hotTable.hotInstance.setDataAtCell(changes)
        },
        getData () {
            return data2JsonObject(this.$refs.hotTable.hotInstance.getData())
        },
        getDataRanged (r) {
            let row = Number.NaN
            if (r === undefined) {
                let range = this.$refs.hotTable.hotInstance.getSelectedRange()
                if (!range) {
                    let visibleColumn = this.getVisibleColumnFirst()
                    this.$refs.hotTable.hotInstance.selectCell(0, visibleColumn, 0, visibleColumn)
                    range = this.$refs.hotTable.hotInstance.getSelectedRange()
                }
                range = range[0]
                row = range.from.row
            } else {
                row = r
            }
            if (Number.isNaN(row)) {
                return
            }

            let data = this.getData()
            if (row >= data.length) {
                return
            }

            return data[row]
        },
        onClickSelectSkuIndividually (sku) {
            console.log('onClickSelectSku', sku)
            this.$emit('click-select-data', [ sku ], true)
        },
        jsonObject2Data (jsonObject) {
            return jsonObject2Data(jsonObject)
        },
        print () {
            let rows = []
            let ids = []
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (Array.isArray(ranges)) {
                for (let i = 0; i < ranges.length; i++) {
                    let row = ranges[i].from.row
                    rows = rows.concat([...Array(ranges[i].to.row - ranges[i].from.row + 1)].map((_, j) => j + ranges[i].from.row))
                }
                rows = Array.from(new Set(rows))
                for (let i = 0; i < rows.length; i++) {
                    let data = this.getDataRanged(rows[i])
                    ids.push(data.id)
                }
            }
            console.log(ids)
            this.$store
                .dispatch('shipping/print', { ids: ids, })
                .catch((error) => {
                    console.log(error)
                    if (error.response.status === 404) {
                        this.$store.dispatch('notification/push', { color: 'danger', text: 'このデータは印刷できません。', life: 25, })
                    }
                })
        },
        downloadStep1 () {
            console.log('downloadStep1')
            let rows = []
            let ids = []
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (Array.isArray(ranges)) {
                for (let i = 0; i < ranges.length; i++) {
                    let row = ranges[i].from.row
                    rows = rows.concat([...Array(ranges[i].to.row - ranges[i].from.row + 1)].map((_, j) => j + ranges[i].from.row))
                }
                rows = Array.from(new Set(rows))
                for (let i = 0; i < rows.length; i++) {
                    let data = this.getDataRanged(rows[i])
                    ids.push(data.id)
                }
            }
            console.log(ids)
            this.$store
                .dispatch('shipping/print', { ids: ids, })
                .catch((error) => {
                    console.log(error)
                    if (error.response.status === 404) {
                        this.$store.dispatch('notification/push', { color: 'danger', text: 'このデータは印刷できません。', life: 25, })
                    }
                })
        },
        addRow () {
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            let rowNew = 0
            if (!ranges) {
                this.$refs.hotTable.hotInstance.alter('insert_row_below')
                rowNew++
            } else {
                for (let i = ranges.length - 1; i >= 0; i--) {
                    this.$refs.hotTable.hotInstance.alter('insert_row_below', ranges[i].from.row + 0)
                    rowNew = ranges[i].from.row + 1
                }
            }
            let visibleColumn = this.getVisibleColumnFirst()
            this.$refs.hotTable.hotInstance.selectCell(rowNew, visibleColumn, rowNew, visibleColumn)

            this.loadPartialData([ this.shipping_default, ])
        },
        removeRow () {
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (!ranges) {
                this.$refs.hotTable.hotInstance.alter('remove_row')
            } else {
                for (let i = ranges.length - 1; i >= 0; i--) {
                    const count = this.$refs.hotTable.hotInstance.countRows()
                    if (count <= ranges[i].from.row) {
                        continue
                    }
                    this.$refs.hotTable.hotInstance.alter('remove_row', ranges[i].from.row, ranges[i].to.row - ranges[i].from.row + 1)
                }
            }

            if (!this.$refs.hotTable.hotInstance.getData().length) {
                this.loadData([{}])
            }

            this.deselectCell()
        },
        deselectCell () {
            this.$refs.hotTable.hotInstance.deselectCell()
        },
    },
}

export default app
</script>

<style lang="scss">
@mixin insuranceTableThMixin($column_counts, $column_colors) {
    $index: 2;
    @each $key, $count in $column_counts {
        @for $i from 0 through $count {
            &:nth-child(#{$i + $index}){
                background-color: map-get($column_colors, $key);
            }

        }
        $index: $index + $count;
    }
}

.shipping-table {
    .handsontable {
        $column_colors: (
            system: #fdfdfd,
            courier: #fdfdfd,
            system_updated_at: #111111,
            profile: #777777,
            from: #efefef,
            to: #d9ead3,
            importer: #9dead3,
            shipping: #d9d9d9,
        );
        $column_counts: (
            system: 3,
            courier: 2,
            system_updated_at: 1,
            profile: 0,
            from: 13,
            to: 13,
            importer: 13,
            shipping: 14,
        );
    
        &[mode="read"],
        &[mode="update"] {
            table {
                thead {
                    th {
                        $column_counts: map-merge($column_counts, (
                            system_updated_at: 0,
                            profile: 0,
                        ));
                        @include insuranceTableThMixin($column_counts, $column_colors);
                    }
                }
            }
        }
        &[mode="create"] {
            table {
                thead {
                    th {
                        $column_counts: map-merge($column_counts, (
                            system: 0,
                            system_updated_at: 0,
                            profile: 0,
                        ));
                        @include insuranceTableThMixin($column_counts, $column_colors);
                    }
                }
            }
        }
    
        &[mode="read"] {
            table {
                thead {
                    th {
                        i.required {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
